import { c as _c } from "react/compiler-runtime";
import { useIsLessThanMd } from "@opensea/ui-kit";
import { useOverviewPreviewStore } from "../../../OverviewPreviewProvider/OverviewPreviewProvider";
export const useCollectionBannerMediaPreview = () => {
  const $ = _c(2);
  const heroMedia = useOverviewPreviewStore(_temp);
  const isLessThanMd = useIsLessThanMd();
  const heroMediaData = isLessThanMd ? heroMedia.mobileHeroMedia : heroMedia.desktopHeroMedia;
  if (!heroMediaData) {
    return null;
  }
  let t0;
  if ($[0] !== heroMediaData) {
    t0 = getMediaUrl(heroMediaData);
    $[0] = heroMediaData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useCollectionBannerMediaFallbackPreview = () => {
  const $ = _c(2);
  const heroMedia = useOverviewPreviewStore(_temp2);
  const isLessThanMd = useIsLessThanMd();
  const heroMediaData = isLessThanMd ? heroMedia.mobileHeroMedia : heroMedia.desktopHeroMedia;
  if (!heroMediaData) {
    return null;
  }
  let t0;
  if ($[0] !== heroMediaData) {
    t0 = getThumbnailUrl(heroMediaData);
    $[0] = heroMediaData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function getMediaUrl(media) {
  switch (media.mediaType) {
    case "VideoMedia":
      return media.videoUrl || null;
    case "ImageMedia":
      return media.imageUrl || null;
    case "MuxVideoMedia":
      return media.muxPlaybackId || null;
    default:
      return null;
  }
}
function getThumbnailUrl(media) {
  switch (media.mediaType) {
    case "VideoMedia":
    case "MuxVideoMedia":
      return media.thumbnailUrl || null;
    default:
      return null;
  }
}
function _temp(state) {
  return state.heroMedia;
}
function _temp2(state) {
  return state.heroMedia;
}